import React from 'react';
// import MaskedInput from 'react-maskedinput';
import MaskedInput from 'react-text-mask';

const FIRST_LETTER = /[Ii1]/;
const CIRILLIC = /[А-ЕЖ-ЩЬЮЯЇІЄҐа-еж-щьюяїієґ]/;

export default function ChildBirthSertificateSeries2002Input(props) {
  return (
    <MaskedInput
      {...props}
      mask={[/[Ii1]/, '-', /[А-ЕЖ-ЩЬЮЯЇІЄҐ]/, /[А-ЕЖ-ЩЬЮЯЇІЄҐ]/]}
      guide={false}
      placeholderChar='*'
      formatCharacters={{
        A: {
          validate: char => FIRST_LETTER.test(char),
          transform: char => char.toUpperCase()
        },
        W: {
          validate: char => CIRILLIC.test(char),
          transform: char => char.toUpperCase()
        }
      }}
    />
  );
}
